export default __webpack_public_path__ + "static/media/Aura-Egg__42.28a8b6e0.png";